import wrapped, { RecordsResourceUsage } from './RecordsResourceUsage.es6';

export default wrapped;
export { RecordsResourceUsage };



// WEBPACK FOOTER //
// ./src/javascripts/components/RecordsResourceUsage/index.es6.js